export default __webpack_public_path__ + "static/ItHarware-3e87c6ddcd4c8b5a977690e4b98971f3.jpeg";